import { useParentalPinStore } from 'hooks/common/useParentalPinStore';

export function useContentRestriction(isAdult: boolean): boolean {
  const parentalPinStore = useParentalPinStore();
  const isBlockByAdult = !parentalPinStore.isAdultPinEntered;
  const isContentRestricted = !!(isAdult && isBlockByAdult);

  return isContentRestricted;
}
